import React, { useMemo, useState, useCallback } from "react";
import { useHistory } from 'react-router-dom';
import { useBeforeunload } from 'react-beforeunload';
import AppLayoutBase from "aws-northstar/layouts/AppLayout";
import HeaderBase from "aws-northstar/components/Header";
import Button from "aws-northstar/components/Button";
import { CONNECT_URL } from "../config";
import { useAgent } from "../hooks";
import { genLogger } from "../lib";

const name = "AppLayout";
const { log, error } = genLogger(name);

const AppLayout = ({ children }) => {
  const [agentInitialized, setAgentInitialized] = useState(false);
  const [agentName, setAgentName] = useState("");
  const [agentStates, setAgentStates] = useState({});
  const history = useHistory();

  const onAgent = useCallback((a) => {
    try {
      const name = a.getName();
      log("name: ", name);
      if (name === null) {
        throw new Error("name was null");
      }
      setAgentInitialized(true);
      setAgentName(name);
      setAgentStates(a.getAgentStates());
      
    } catch (e) {
      error("couldn't set agent data", e);
    }
  }, []);
  useAgent(onAgent);

  useBeforeunload(() => {
    setStatusToOffline();
  });

  const setStatusToOffline = useCallback(() => {
    let offlineState = agentStates.filter(state => state.name === "Offline")[0];

    window.connect.agent((agent) => {
      agent.setState(offlineState, {
        success: function() {
          log("Set Offline Success");
        },
        failure: function() {
          log("Set Offline Failed");
        }
      })
    })
  },[agentStates])

  const handleLogout = useCallback(() => {
    setStatusToOffline();
    fetch(CONNECT_URL+'logout', { credentials: 'include', mode: 'no-cors'} )
      .then(() => {
        setAgentInitialized(false);
        setAgentName("");
        window.connect.core.terminate();
        history.push("/logout");
      });
  },[setAgentInitialized, setAgentName, setStatusToOffline, history]);



  const Header = useMemo(
    () => (
      <HeaderBase
        title={'Current Agent: ' + agentName}
        logoPath={process.env.PUBLIC_URL + 'phone.png'}
        rightContent={<Button 
                          type="submit"
                          size="large"
                          disabled={!agentInitialized} 
                          onClick={handleLogout}
                          style={{backgroundColor: "#f5f5f5", padding:"9px 30px", fontSize:"15px"}}
                          >Logout</Button>
                      }
      />
    ),
    [agentInitialized, agentName, handleLogout]
  );  

  return (
    <AppLayoutBase
      header={Header}
    >
      {children}
    </AppLayoutBase>
  );
};

export default AppLayout;
